import React, { useState } from 'react';
import { Select, Button, DatePicker, Tooltip, Icon, Dropdown, Menu } from 'antd';

import Grid from '@material-ui/core/Grid';
import { styles, useStyles } from './EvaluationFormStyles';
import TextEvents from 'app/components/TextEvents';

import TableContainer from 'app/containers/TableContainer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTest, clearTest, exportTemplateTest } from 'app/actions/TestActions';
import ApiService from 'app/services/ApiService';
import moment from 'moment';


const { Option } = Select;

const SelectItem = (name = [], value) => {
  let x = name[value]
  return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function EvaluationForm(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [collapse, setCollapse] = useState(true);
  let [id, setId] = useState([]);
  let [status, setStatus] = useState([]);
  let [subdirec, setSubdirect] = useState([]);
  let [name, setName] = useState([]);
  let [courseFolio, setCourseFolio] = useState([]);
  let [ListTraining, setListTraining] = useState([]);
  let [training, setTraining] = useState([]);
  const { idSubdirection, employeeId } = useSelector((state) => state.Auth.employeeById);
  const { siteId } = useSelector(state => state.Auth);
  const [creationDateI, setCreationDateI] = useState("");
  const [creationDateF, setCreationDateF] = useState("");
  const [modificationDateI, setModificationDateI] = useState("");
  const [modificationDateF, setModificationDateF] = useState("");
  // eslint-disable-next-line no-unused-vars
  let [desc, setDesc] = useState([]);
  let [subdirList, setSubdirList] = useState();
  const data = {
    TestFolio: id.toString(),
    CourseFolio: courseFolio,
    TestTitle: name.length > 0 ? name[0].join("|") : '',
    ListStatus: status,
    Subdirection: idSubdirection,
    EmployeeId: employeeId,
    InitialCreationDate: creationDateI,
    FinalCreationDate: creationDateF,
    InitialRevDate: modificationDateI,
    FinalRevDate: modificationDateF,
    ListTraining: training,
    sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
    sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
    offset: (0 * props.pagination.pageSize),
    limit: props.pagination.pageSize
  }

  const SelectSubdirItem = (name = [], value) => {
    setSubdirList(name);
    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
      x.map((c, i) => <Option key={i}>{c}</Option>)
    );
  }

  //Este es para los controles de filtro
  const SelectTrainingItem = (name = [], value) => {
    //var filtered = name.filter(el => el != null);
    //setListTraining(filtered);
    setListTraining(name);
    let x = [...new Set(name.map((i) => i[value]))];
    x = name.map((i) => i[value]);
    return x.map((c, i) => <Option key={i}>{c}</Option>);
  };

  const search = (params) => {
    dispatch(clearTest());
    dispatch(fetchTest(data));
    props.setFormData(data);
  }

  const toExport = async () => {
    await ApiService.getExportToExcel(data)
      .then(
        result => {
          const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          downloadFile(blob, "BandejaEvaluaciones.xlsx");
        },
        error => {
          // eslint-disable-next-line no-throw-literal
          throw ({ error: error, message: 'An error ocurred' });
        }
      )
  }

  const exportTemplateTest = async () => {

    let param = {
      fileName: 'LayoutEvaluacion.xlsx',
    }

    await ApiService.getTestTemplate(param).then(
      result => {
        const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        downloadFile(blob, `${param.fileName}`);
      }
    ).catch(
      (error) => {
        // eslint-disable-next-line no-throw-literal
        throw ({ error: error, message: 'An error ocurred' });
      }
    )
  }

  const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
  };

  const disabledCStartDate = (current) => {
    if (creationDateF === "") {
      return false;
    } else {
      if (moment(current.format('YYYY-MM-DD')) > moment(creationDateF)) {
        return true;
      } else return false;
    }
  }
  const disabledCEndDate = (current) => {
    if (creationDateI === "") {
      return false;
    } else {
      if (moment(current.format('YYYY-MM-DD')) < moment(creationDateI)) {
        return true;
      } else return false;
    }
  }

  const disabledMStartDate = (current) => {
    if (modificationDateF === "") {
      return false;
    } else {
      if (moment(current.format('YYYY-MM-DD')) > moment(modificationDateF)) {
        return true;
      } else return false;
    }
  }
  const disabledMEndDate = (current) => {
    if (modificationDateI === "") {
      return false;
    } else {
      if (moment(current.format('YYYY-MM-DD')) < moment(modificationDateI)) {
        return true;
      } else return false;
    }
  }

  const handleChange = (value, i, key) => {
    const array = [];
    i.map(i => {
      array.push(i.props.children);
      return array;
    })
    if (i.length === 0) {
      switch (key) {
        case 'testFolio':
          setId([])
          break;
        case 'courseFolio':
          setCourseFolio([])
          break;
        case 'statusName':
          setStatus([])
          break;
        case 'testTitle':
          setName([])
          break;
        case 'testDescription':
          setDesc([])
          break;
        case 'trainingName':
          setTraining([]);
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line array-callback-return
    i.map(() => {
      if (key === 'testFolio') {
        setId([array]);
      } else if (key === 'courseFolio') {
        setCourseFolio([array]);
      }/* else if(key === 'subdirectionName'){
                let newsubdirList=[];
                array.map(i=>{
                    // eslint-disable-next-line array-callback-return
                    return subdirList.map(ids=>{
                        if (ids.subdirectionName===i ) {
                            const res = ids['idSubdirection'];
                            newsubdirList.push(res);
                        }
                    })
                })
                setSubdirect([newsubdirList])
            } */
      else if (key === 'statusName') {
        setStatus([array])
      } else if (key === 'testTitle') {
        setName([array])
      } else if (key === "trainingName") {
        let newListTraining = [];
        array.map((i) => {
          // eslint-disable-next-line array-callback-return
          return ListTraining.map((ids) => {
            if (ids.trainingName === i) {
              const res = ids["idTraining"];
              newListTraining.push(res);
            }
          });
        });
        setTraining([newListTraining]);
      }
      else if (key === 'testDescription') {
        setDesc([array])
      }
    })
  }

  // const menu = (
  //   <Menu onClick={handleMenuClick}>
  //     <Menu.Item key="1">
  //       Evaluacion
  //     </Menu.Item>
  //     <Menu.Item key="2">
  //       Carga Masiva
  //     </Menu.Item>
  //   </Menu>
  // );

  return (
    <div>
      <TableContainer>
        {(params) => {
          return (
            <div>
              <div hidden={collapse}>
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <TextEvents
                      text="Folio"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                      style={styles.inputSelect}
                      placeholder="Selecciona folio"
                      onChange={(v, i) => handleChange(v, i, "testFolio")}
                    >
                      {SelectItem(params.testFilter[0], "folio")}
                    </Select>
                  </Grid>

                  <Grid item xs={6}>
                    <TextEvents
                      text="Nombre"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                      style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                      placeholder="Selecciona nombre"
                      onChange={(v, i) => handleChange(v, i, "testTitle")}
                    >
                      {SelectItem(params.testFilter[0], "title")}
                    </Select>
                  </Grid>
                </Grid>

                <Grid container direction="row">
                  <Grid item xs={6}>
                    <TextEvents
                      text="Tipo de Capacitación:"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                      style={styles.inputSelect}
                      placeholder="Selecciona Tipo de Capacitación"
                      onChange={(v, i) => handleChange(v, i, "trainingName")}
                    >
                      {params.testFilter[0] !== undefined
                        ? SelectTrainingItem(
                          params.testFilter[0].training,
                          "trainingName"
                        )
                        : null}
                    </Select>
                  </Grid>

                  <Grid item xs={6}>
                    <TextEvents
                      text="Estatus"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                      style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                      placeholder="Selecciona estatus"
                      onChange={(v, i) => handleChange(v, i, "statusName")}
                    >
                      {SelectItem(params.testFilter[0], "statusName")}
                    </Select>
                  </Grid>
                </Grid>

                <Grid container spacing={1} direction="row">
                  <Grid item xs={6}>
                    <TextEvents
                      text="Fecha de Creación"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Grid container spacing={1} direction="row">
                      <Grid item xs={6}>
                        <DatePicker
                          style={{
                            ...styles.fullWidth,
                            ...styles.smallBottomMargin,
                          }}
                          disabledDate={disabledCStartDate}
                          format={"DD/MM/YYYY"}
                          onChange={(date, dateString) => {
                            setCreationDateI(
                              dateString !== ""
                                ? dateString.split("/").reverse().join("/")
                                : ""
                            );
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DatePicker
                          style={{
                            ...styles.fullWidth,
                            ...styles.smallBottomMargin,
                          }}
                          disabledDate={disabledCEndDate}
                          format={"DD/MM/YYYY"}
                          onChange={(date, dateString) => {
                            setCreationDateF(
                              dateString !== ""
                                ? dateString.split("/").reverse().join("/")
                                : ""
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <TextEvents
                      text="Folio de Procedimiento"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                      style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                      placeholder="Selecciona folio procedimiento"
                      onChange={(v, i) => handleChange(v, i, "courseFolio")}
                    >
                      {SelectItem(params.testFilter[0], "courseFolio")}
                    </Select>
                  </Grid>
                </Grid>

                <Grid container spacing={1} direction="row">
                  <Grid item xs={6}>
                    <TextEvents
                      text="Fecha de Modificación"
                      color="darker"
                      size="label"
                      weight="medium"
                    />
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={6}>
                        <DatePicker
                          style={{
                            ...styles.fullWidth,
                            ...styles.smallBottomMargin,
                          }}
                          disabledDate={disabledMStartDate}
                          format={"DD/MM/YYYY"}
                          onChange={(date, dateString) => {
                            setModificationDateI(
                              dateString !== ""
                                ? dateString.split("/").reverse().join("/")
                                : ""
                            );
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DatePicker
                          style={{
                            ...styles.fullWidth,
                            ...styles.smallBottomMargin,
                          }}
                          disabledDate={disabledMEndDate}
                          format={"DD/MM/YYYY"}
                          onChange={(date, dateString) => {
                            setModificationDateF(
                              dateString !== ""
                                ? dateString.split("/").reverse().join("/")
                                : ""
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div
                className={classes.container}
                style={styles.baseVerticalMargin}
              >
                {
                  collapse ?
                    <Tooltip title={"Mostrar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(false)}
                      >
                        <Icon type="down" />
                      </Button>
                    </Tooltip> :
                    <Tooltip title={"Ocultar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(true)}
                      >
                        <Icon type="up" />
                      </Button>
                    </Tooltip>
                }
                <Button
                  className={classes.button}
                  variant="contained"
                  type="primary"
                  onClick={() => search(params)}
                >
                  Buscar
                </Button>
                <Button
                  className={classes.button}
                  variant="contained"
                  type="primary"
                  onClick={toExport}
                >
                  Exportar
                </Button>
                {
                  siteId === 'HUB' ?

                    <Button
                      className={classes.button}
                      variant="contained"
                      type="primary"
                      onClick={() => {
                        props.setTab("2");
                      }}
                    >
                      Nuevo
                    </Button>
                    : null
                }


                <Button
                  className={classes.button}
                  onClick={exportTemplateTest}
                  type="primary"
                  variant="contained"
                  icon="file-excel"
                  style={{ backgroundColor: '#288504', borderColor: "#288504" }} >
                  Descargar Template
                </Button>
              </div>
            </div>
          );
        }}
      </TableContainer>
    </div>
  );
}